export function appendQueryParameters(
  baseUrl: string,
  params: { [key: string]: string | undefined | null },
): string {
  if (!baseUrl?.trim()) return '';

  try {
    const parsedUrl = new URL(baseUrl);
    Object.keys(params).forEach(key => {
      const val = params[key];
      if (val && !parsedUrl.searchParams.has(key)) {
        parsedUrl.searchParams.set(key, val);
      }
    });
    return parsedUrl.toString();
  } catch {
    return baseUrl;
  }
}
